/** @jsx jsx */
import { Title } from '@bottlebooks/gatsby-design-system';
import { Col, Container, Row } from '@bottlebooks/gatsby-theme-base';
import BrandBanner from '@bottlebooks/gatsby-theme-event/src/components/Brand/BrandBanner';
import ChangeProductListLink from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ChangeExhibitorLink';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/';
import ProductListRow from '@bottlebooks/gatsby-theme-event/src/components/ProductsList/ProductListRow';
import ProductsList from '@bottlebooks/gatsby-theme-event/src/components/ProductsList/ProductsList';
import { resolve } from '@bottlebooks/gatsby-theme-event/src/helpers/path';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
// import ProductListActions from '@bottlebooks/gatsby-theme-event/src/components/Exhibitor/ExhibitorActions';
// import { Trans } from '@lingui/macro';

export default function ProductListPage({
  producer,
  productList,
  products,
  previous,
  next,
  paths = {},
}) {
  const hasProducts = products && products.length !== 0;
  return (
    <Layout paths={paths} sx={{ backgroundColor: 'transparent' }}>
      <BrandBanner {...producer} />
      <Container>
        <Row
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            paddingY: 4,
          }}
        >
          <Col
            sx={{
              flex: '1',
              minWidth: ['100%', 'unset'],
              order: [1, 'unset'],
            }}
          >
            <Title variant="large">{productList && productList.name}</Title>
          </Col>
          <Col sx={{ order: -1, minWidth: `${100 / 12}%`, textAlign: 'right' }}>
            <ChangeProductListLink
              exhibitor={previous}
              to={resolve([paths.productLists, previous?.slug])}
              direction="previous"
              sx={{ marginLeft: -4, marginRight: -3 }}
            />
          </Col>
          <Col sx={{ minWidth: `${100 / 12}%` }}>
            <ChangeProductListLink
              exhibitor={next}
              to={resolve([paths.productLists, next?.slug])}
              sx={{ marginLeft: -3, marginRight: -4 }}
            />
          </Col>
        </Row>

        {/* <Row
          sx={{
            paddingY: 3,
            paddingX: [null, `${100 / 12}%`] // 1 col spacing from medium width up.
          }}
        >
          <Col>
            <ProductListActions exhibitor={productList} />
          </Col>
        </Row> */}
      </Container>

      {hasProducts ? (
        <Container>
          <Row
            sx={{
              paddingTop: 4,
              paddingX: [null, `${100 / 12}%`], // 1 col spacing from medium width up.
            }}
          >
            <Col flex>
              {hasProducts && (
                <ProductsList sx={{ marginX: [-3, -2], marginY: -2 }}>
                  {products.map(product => (
                    <ProductListRow
                      key={product.id}
                      product={product}
                      to={resolve([paths.productBase, product.slug])}
                      sx={{ marginX: [0, 2], marginY: [0, 2] }}
                    />
                  ))}
                </ProductsList>
              )}
            </Col>
          </Row>
        </Container>
      ) : null}
    </Layout>
  );
}

export const fragment = graphql`
  fragment ProductListPage_Query on Query {
    exhibitor {
      ...BrandBanner
    }
  }
  fragment ProductListPage_Product on Product {
    id
    slug
    ...ProductListRow
  }
  fragment ProductListPage_ChangeLink on Event {
    id
    slug
    name
  }

  fragment ProductListPage on Event {
    name
    products {
      id
      name
      ...ProductListPage_Product
    }
  }
`;
